import { SKIPSCREEN_DASHBOARD_REFRESH_EVENT } from './realtimeEvents';

/** Notify dashboard widgets to refetch activity, trends, and metrics. */
export function refreshDashboardRealtime(): void {
  window.dispatchEvent(new Event(SKIPSCREEN_DASHBOARD_REFRESH_EVENT));
}
